import { CommonModule } from '@angular/common'
import {
    Component,
    input,
    computed,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { injectCurrentUser, injectIsMobile } from '@mattrika/benefit-core'
import { HeaderVendorComponent } from '../../headers/header-vendor/header-vendor.component'
import { NavigationGroup } from '../../sidebars/sidebar-admin-default/sidebar.model'
import { SidebarVendorComponent } from '../../sidebars/sidebar-vendor/sidebar-vendor.component'
import { vendorNavigationGroups } from '../../sidebars/sidebar-vendor/sidebar-vendor.data'

@Component({
    selector: 'app-layout-vendor',
    imports: [CommonModule, SidebarVendorComponent, HeaderVendorComponent],
    templateUrl: './layout-vendor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-vendor.component.css',
})
export class LayoutVendorComponent {
    logoSrc = input('assets/images/cjc.svg')
    logoAlt = input('Benefit Logo')
    companyName = input('ABC Restaurant')
    userName = input('')
    navigationGroups = input<NavigationGroup[]>(vendorNavigationGroups)

    readonly user = injectCurrentUser()
    private readonly isMobile = injectIsMobile()

    readonly effectiveCompanyName = computed(
        () =>
            this.companyName() || this.user.companyName() || 'Vendor Workspace',
    )

    isSidebarCollapsed = signal(false)
    isMobileSidebarOpen = signal(false)

    toggleSidebar() {
        if (this.isMobile()) {
            this.isMobileSidebarOpen.update((v) => !v)
        } else {
            this.isSidebarCollapsed.update((v) => !v)
        }
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen.set(false)
    }
}
